import { render, staticRenderFns } from "./Konzorcijumi.vue?vue&type=template&id=2e5089ce&"
import script from "./Konzorcijumi.vue?vue&type=script&lang=js&"
export * from "./Konzorcijumi.vue?vue&type=script&lang=js&"
import style0 from "./Konzorcijumi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports